export default "__VITE_ASSET__ByhQ45TR__"